import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { useLang } from "../context/LangContext";
import { STATIC_PARTNERS, PARTNER_ICONS } from "../data/partners";
import { resolveMedia } from "../data/projects";

export default function Partners() {
  const { t } = useLang();
  const [partners, setPartners] = useState(STATIC_PARTNERS);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/partners`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => {
        if (Array.isArray(d) && d.length) setPartners(d);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="partners" data-testid="partners-section" className="relative py-20 lg:py-32 bg-white/40 border-y border-[#E8DFC5]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeader
          index={t.partners.index}
          eyebrow={t.partners.eyebrow}
          title={t.partners.title}
          description={t.partners.desc}
        />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 lg:gap-6">
          {partners.map((p, i) => {
            const Icon = PARTNER_ICONS[p.icon] || Building2;
            return (
              <Reveal key={p.id} delay={(i % 6) * 0.06}>
                <div
                  data-testid={`partner-card-${p.id}`}
                  className="group flex items-center gap-4 rounded-lg border border-[#E8DFC5] bg-white p-5 lg:p-6 transition-all duration-300 hover:border-emerald-500/50 hover:bg-[#F5EEDC] hover:-translate-y-1.5"
                >
                  {p.logo ? (
                    <img
                      data-testid={`partner-logo-${p.id}`}
                      src={resolveMedia(p.logo)}
                      alt={`شعار ${p.name}`}
                      className="w-14 h-14 shrink-0 rounded-full border border-[#E8DFC5] bg-white object-contain p-1.5 transition-transform duration-300 group-hover:scale-105"
                    />
                  ) : (
                    <span className="w-14 h-14 shrink-0 rounded-full bg-emerald-500/10 border border-emerald-500/25 flex items-center justify-center transition-colors duration-300 group-hover:bg-emerald-500">
                      <Icon className="w-6 h-6 text-emerald-600 transition-colors duration-300 group-hover:text-white" strokeWidth={1.8} />
                    </span>
                  )}
                  <div className="min-w-0">
                    <h3 className="font-heading font-semibold text-base sm:text-lg text-stone-800 leading-snug">
                      {p.name}
                    </h3>
                    <p className="mt-1.5 font-accent text-xs tracking-wide text-stone-500">{p.tag}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
